import { Api } from "api";

export const getMiniAppNotifications = async (searchParams: URLSearchParams, page?: number) => {
  let url = "/notifications/v1/admin/mini_app_notifications";
  let params = searchParams ? `?${searchParams}` : "";
  const res = await Api.get(`${url}${params}`, {
    params: { page },
  });
  return res.data;
};

export const getNotificationsEnabledByUsers = async (searchParams: URLSearchParams, page?: number) => {
  let url = "/notifications/v1/admin/users_notifications";
  let params = searchParams ? `?${searchParams}` : "";
  const res = await Api.get(`${url}${params}`, {
    params: { page },
  });
  return res.data;
};
